<section class="cards-list">
    <mat-card *ngFor="let card of cards" [ngClass]="{'mobile-hidden': card.isMobileHidden}">
        <mat-card-header>
            <div mat-card-avatar>
                <mat-icon aria-label="Title-Icon">{{card.icon}}</mat-icon>
            </div>
            <mat-card-title>
                <h2>{{card.title | translate}}</h2>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>
                {{ card.content | translate }}
            </p>
        </mat-card-content>
        <mat-card-actions>
            <a *ngIf="card.route" mat-button color="accent" [routerLink]="[card.route]">
                {{card.linkLabel | translate}}
                <mat-icon aria-label="Go">keyboard_arrow_right</mat-icon>
            </a>
            <a *ngIf="card.url" mat-button color="accent" [attr.href]="card.url" target="_blank">
                {{card.linkLabel | translate}}
                <mat-icon aria-label="Go">keyboard_arrow_right</mat-icon>
            </a>
        </mat-card-actions>
    </mat-card>
</section>
